<template>
  <div class="main">
    <b-card>
      <b-row>
        <b-col md="2" sm="4" class="my-1">
          <b-form-group class="mb-0">
            <label class="d-inline-block text-sm-left mr-50">Per page</label>
            <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
            />
          </b-form-group>
        </b-col>
        <b-col md="4" sm="8" class="my-1">
          <b-form-group
            label="Sort"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="sortBySelect"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-select
                id="sortBySelect"
                v-model="sortBy"
                :options="sortOptions"
                class="w-75"
              >
                <template v-slot:first>
                  <option value="">-- none --</option>
                </template>
              </b-form-select>
              <b-form-select
                v-model="sortDesc"
                size="sm"
                :disabled="!sortBy"
                class="w-25"
              >
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="6" class="my-1">
          <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
          >
            <b-input-group size="sm">
              <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              />
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">
                  Clear
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-table
            striped
            hover
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="itemsEmp"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >

          <template #cell(startDate)="data">
                    {{ formatDate(data.item.startDate) }}
                  </template>
                  <template #cell(employeeId)="data">
                    {{ getEmployee(data.item.employeeId) }}
                  </template>
                  <template #cell(returnDate)="data">
                    {{ formatDate(data.item.returnDate) }}
                  </template>

                  <template #cell(managerId)="data">
                    {{ getEmployee(data.item.managerId) }}
                  </template>

                  <template #cell(leaveTypeID)="data">
                    {{ getLeaveType(data.item.leaveTypeID) }}
                  </template>

                  <template #cell(approvedDate)="data">
                    {{ formatDate(data.item.approvedDate) }}
                  </template>

                  <template #cell(status)="data">
                    <b-badge :variant="statusVariants[data.item.status]">
                      {{ data.item.status }}
                    </b-badge>
                  </template>

            <template v-slot:cell(actions)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  class="m-1"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>
                  <b-dropdown-item :disabled="data.item.status !== 'PENDING'" @click="approvalAction('APPROVED', data.item.leaveRequestId)"
                  >
                    <feather-icon icon="CheckCircleIcon" />
                    <span class="align-middle ml-50">Approved</span>
                  </b-dropdown-item>
                  <b-dropdown-item :disabled="data.item.status !== 'PENDING'" @click="approvalAction('REJECTED', data.item.leaveRequestId)"
                  >
                    <feather-icon icon="XCircleIcon" />
                    <span class="align-middle ml-50">Rejected</span>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
              <!-- <template #cell(details)="data">
                {{ data.item.leaveRequestId }}
              </template> -->
          </b-table>
        </b-col>

        <b-col cols="12">
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-0"
          />
        </b-col>
        <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BCard,
  BDropdown,
  BLink,
  BDropdownItem,
} from "bootstrap-vue";
import { mapGetters, mapActions } from 'vuex';
import { IsAdmin } from "@/@core/utils/validations/permissionCheck";
export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BDropdownItem,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      filter: null,
      filterOn: [],
      fields: [
      { key: "employeeId", label: "Employee Name", sortable: true },
        { key: "leaveTypeID", label: "Leave Type", sortable: true },
        { key: "startDate", label: "Start Date", sortable: true },
        { key: "returnDate", label: "End Date", sortable: true },
        {
          key: "leaveDurationType",
          label: "Leave Duration Type",
          sortable: true,
        },
        { key: "notes", label: "Notes", sortable: true },
        {
          key: "managerId",
          label: "Approving Manager",
          sortable: true,
        },
        { key: "days", label: "Days", sortable: true },
        { key: "approvedDate", label: "Date Approved", sortable: true },
        { key: "status", label: "Status", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      statusVariants: {
        APPROVED: "success",
        PENDING: "warning",
        REJECTED: "danger",
      },
      status: [
        {
        APPROVED: "APPROVED",
        PENDING: "PENDING",
        REJECTED: "REJECTED",
        },
        {
          APPROVED: "success",
          PENDING: "warning",
          REJECTED: "danger",
        },
      ],
      filtered_items: [

      ],
      itemsEmp:[],
      // items: [
      //   {
      //     employee_name: "Employee 1",
      //     leave_type: "Annual Leave",
      //     start_date: "27.05.2024",
      //     return_date: "29.05.2024",
      //     leave_duration_type: "Full Day Leave",
      //     notes: "Notes here",
      //     time_requested: "3 days",
      //     status: 1,
      //   },
      //   {
      //     employee_name: "Employee 2",
      //     leave_type: "Annual Leave",
      //     start_date: "27.05.2024",
      //     return_date: "29.05.2024",
      //     leave_duration_type: "Full Day Leave",
      //     notes: "Notes here",
      //     time_requested: "3 days",
      //     status: 2,
      //   },
      //   {
      //     employee_name: "Employee 3",
      //     leave_type: "Annual Leave",
      //     start_date: "27.05.2024",
      //     return_date: "29.05.2024",
      //     leave_duration_type: "Full Day Leave",
      //     notes: "Notes here",
      //     time_requested: "3 days",
      //     status: 3,
      //   },
      //   {
      //     employee_name: "Employee 4",
      //     leave_type: "Annual Leave",
      //     start_date: "27.05.2024",
      //     return_date: "29.05.2024",
      //     leave_duration_type: "Full Day Leave",
      //     notes: "Notes here",
      //     time_requested: "3 days",
      //     status: 4,
      //   },
      // ],
    };
  },

  computed: {
    ...mapGetters('leaverequestModule', {
      items: 'subordinate',
      leaverequests: 'leaverequests',
            loading: 'loading',
    }),

    ...mapGetters("employeeModule", {
      employeeList: "employees",
      loading: "loading",
    }),

    ...mapGetters('leavetypeModule', {
            leavetypes: 'leavetypes',
            loading: 'loading',
        }),
  },
  methods: {
    ...mapActions('leaverequestModule', [
            'getLeaveRequestSubordinatesAction',
            'putLeaveRequestApprovalAction', 'getLeaveRequestListAction'
        ]),

        ...mapActions("employeeModule", ["getEmployeeListAction"]),

        ...mapActions("leavetypeModule", ["getLeaveTypeListAction"]),

        getEmployee(id) {
      const employee = this.employeeList.find((s) => s.id === id);
      return employee ? employee.firstName + " " + employee.lastName : "-";
    },

    getLeaveType(id) {
      const leave = this.leavetypes.find((s) => s.leaveTypeId === id);
      return leave ? leave.title : "-";
    },

    // formatDate(date) {
    //   const options = { year: "numeric", month: "short", day: "numeric" };
    //   return new Date(date).toLocaleDateString("en-US", options);
    // },

    formatDate(date) {
      if(date != null){
        const options = { year: "numeric", month: "short", day: "numeric" };
        return new Date(date).toLocaleDateString("en-US", options);
      }
      else {
        return "-";
      }
      
    },

    success(message) {
      this.$swal({
        title: "Leave Request Status Updated!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    async approvalAction(status, id) {

      //console.log("idddddddddddddddddddddddddddddddddddddddd", id);
      try {
        
        // confirm update
        const result = await this.$swal({
          title: "Are you sure?",
          text: "You will not be able to revert your changes!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, update status!",
          cancelButtonText: "Cancel",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        });

        if (result.isConfirmed) {
          const payload = {
  id: id,
  status: status
}
          
          try {
            await this.putLeaveRequestApprovalAction(payload);
            this.success();
            await this.getLeaveRequestSubordinatesAction();
          } catch (updateError) {
            console.error("Error updating leave request:", updateError);
            await this.$swal({
              title: "Error",
              text: "An error occurred while updating the leave request.",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-danger",
              },
            });
          }
        }
      } catch (error) {
        console.error("Error fetching leave request:", error);
        await this.$swal({
          title: "Error",
          text: "An error occurred while fetching the leave request data.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
      }
    },
  },
  async mounted(){
    await this.getLeaveTypeListAction();

   

if(IsAdmin()){
await this.getLeaveRequestListAction().then(() => {
this.itemsEmp = this.leaverequests;
this.totalRows = this.itemsEmp.length;
});
}
else
{
  await this.getLeaveRequestSubordinatesAction().then(() => {
    this.itemsEmp = this.items;
    this.totalRows = this.itemsEmp.length;
  });
}

        await this.getEmployeeListAction().then(() => {
      this.employeeOptions = this.employeeList.map((employee) => ({
        value: employee.id,
        text: `${employee.firstName} ${employee.lastName}`,
      }));
    });
  },
  setup() {
    return {
      IsAdmin
    }
  }

};
</script>
